import OrganizationSpecialSalaryEditForm from './OrganizationSpecialSalaryEditForm';

export default OrganizationSpecialSalaryEditForm;
